export default "__VITE_ASSET__wyDOAgtJ__"